import { FigmaTypography } from "@libs/zapi-ui/custom";
import { AuthLogsView } from "./AuthLogsView";

export function AuthLogsPage() {
  return (
    <div className="container mx-auto py-8 pt-[95px] min-h-[calc(100vh-51px-64px)]" data-testid="auth-logs-page">
      <div className="flex justify-between items-center mb-6">
        <FigmaTypography component="h1" variant="heading-1" data-testid="auth-logs-heading">Auth Logs</FigmaTypography>
      </div>

      <AuthLogsView />
    </div>
  );
}
